<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="description" content="" />
  <meta name="author" content="Laiterie du berger" />
  <meta name="generator" content="LDB" />
  <title>{{ 'forgotPassword.pageTitle' | translate }}</title>

  <style>
    .bd-placeholder-img {
      font-size: 1.125rem;
      text-anchor: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }

    @media (min-width: 768px) {
      .bd-placeholder-img-lg {
        font-size: 3.5rem;
      }
    }

  </style>
</head>

<body class="text-center">
  <main class="form-reset">
    <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="message !== ''">
      {{message}}
    </ngb-alert>
    <div class="form-reset-content">
      <div class="card">
        <h5 class="card-header">{{ 'forgotPassword.title' | translate }}</h5>
        <div class="card-body">
            <p class="card-text">{{ 'forgotPassword.description' | translate }}
            </p>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-floating">
              <input formControlName="email" type="email" class="form-control" id="floatingInput"
                placeholder="name@example.com" />
              <label for="floatingInput">{{ 'forgotPassword.form.emailLabel' | translate }}</label>
            </div>
            <div *ngIf="loading" class="spinner-border text-info mt-5" role="status">
              <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
            </div>
            <button [disabled]="!form.valid || loading" *ngIf="!loading" class="mt-5 w-100 btn btn-primary text-white"
              type="submit">
              {{ 'forgotPassword.form.submitButton' | translate }}
            </button>
          </form>
        </div>
      </div>
      <a class="nav-link mt-5 text-info" routerLink="/login">
        {{ 'forgotPassword.backToLoginLink' | translate }}
      </a>
      <p class="mt-5 mb-3 text-muted">{{ 'forgotPassword.footer.copyright' | translate }}</p>
    </div>
  </main>
</body>

</html>
